import Home from './SettingsHome';
import Profile from './Profile';
import AccessManagement from './AccessManagement';
import AccessManagementUser from './AccessManagementUser';
import Security from './SettingsSecurity';
import InviteUser from './InviteUser';

export default {
    Home,
    Profile,
    AccessManagement,
    AccessManagementUser,
    Security,
    InviteUser
};
